export { default } from "./TableHead.js";
export { default as tableHeadClasses } from "./tableHeadClasses.js";
export * from "./tableHeadClasses.js";